import { Routes, Route } from 'react-router-dom';
import VehicleEntryPage from './pages/VehicleEntryPage';
import ResultsPage from './pages/ResultsPage';
import NotFound from './pages/NotFound';
import Footer from './components/footer/footer';

export default function App() {
  return (
    <div className="min-h-screen">
      <Routes>
        <Route path="/" element={<VehicleEntryPage />} />
        <Route path="/results" element={<ResultsPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </div>
  );
}
